module.exports = __webpack_public_path__ + "static/media/virgin_card_1.ca189053.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/virgin_card_1.jpg
// module id = 527
// module chunks = 0